import React, { useEffect, useMemo, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, DatePicker, Divider, Drawer, Dropdown, Form, Image, Input, Select, Space, Switch, Tag, Upload, notification } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useGetProducts } from '../../../hooks/products/products'
import { useAdsApproval, useDeleteAds, useGetAds, useGetAdss, usePutAds, usePostAds } from '../../../hooks/adservices/adservices'
import { useGetSubscriptions } from '../../../hooks/subscription/subscription'

function AdServices() {
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [dateTime, setDateTime] = useState('')
  const [idx, setIdx] = useState('')
  const [image, setImage] = useState({})

  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)

  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)

  const [isOpenApprove, setIsOpenApprove] = useState(false)
  const onOpenApprove = () => setIsOpenApprove(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setIsOpenEdit(false)
    setRows([])
  }
  const onApproveClose = () => {
    form.resetFields()
    setIsOpenApprove(false)
    setRows([])
  }
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }
   
  const [createPayload, setCreatePayload] = useState({    
    detail: "",
    imageForm: "",
    subscriptionId: "",
    startDate: "",
    url: "",
    id:"",
})

const [apPayload, setApPayload] = useState({
  answer: false,
  request: "",
  id:"",
})

  const {
    data: getAdsData,
    refetch: getAdsFetch,
    isFetching: getAdsLoad,
  } = useGetAdss()
  
const {
  data: getSubData,
  isFetching: getSubLoad,
} = useGetSubscriptions()

const {
  data: getData,
  mutate: getAction,
  isLoading: getLoad,
} = useGetAds(onOpenEdit)

  const successAction = () => {
    form.resetFields();
    getAdsFetch();
    onApproveClose()
  };

  useEffect(() => {
    setCreatePayload({
      detail: getData?.data?.detail || "",
      subscriptionId: getData?.data?.subscription?.id || [],
      imageForm: getData?.data?.imageUrl || "",
      startDate: getData?.data?.startDate || "",
      url: getData?.data?.url || "",
      id: getData?.data?.id || "",
    })
    
  }, [getData?.data])

  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
      // setCreatePayload({...createPayload, imageForm: file?.originFileObj})
    }
  }), [image]);

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostAds(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePutAds(successAction)

  const {
    mutate: approvalAction,
    isLoading: approvalLoad,
  } = useAdsApproval(successAction)

  
  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteAds(successAction)

//   const handleView = ({target:{id}}) => {
//     onViewOpen()
//   }
  const handleEdit = (d) => {    
    getAction(d.id)
  }
  const handleApproval = (d) => {    
    setIdx(d.id)
    setApPayload({      
      answer: d.isApproved,
      request: d.request || "",
      id: d.id
    })
    onOpenApprove()
  }


  const columns = [
    {
      title: "Brand Image",
      dataIndex: "imageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={50} />
    },
    {
      title: "Ads Details",
      dataIndex: "detail",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <Avatar src="">{e?.charAt(0)}</Avatar>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Subscription type",
      dataIndex: "subscription",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e.type || 'Nil'}</p>
      </div>,
    },
    {
      title: "Subscription title",
      dataIndex: "subscription",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e.title || 'Nil'}</p>
      </div>,
    },
    {
      title: "Ads URL",
      dataIndex: "url",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Ads StartDate",
      dataIndex: "startDate",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Approval Status",
      dataIndex: "isApproved",
      key:"2",
      render: (e) => 
      <Tag className={`font-bold rounded-2xl px-3 py-0.5`} color={e ? 'green': 'red'}>{e ? "Approved" : "Unapproved"}</Tag>
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          // {key: "status", label: <button className='flex' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit Status</button>},
          {key: "approve", label: <button className='flex' onClick={()=>handleApproval(data)}><BiEdit className='!text-base mx-4 py-auto' /> Approval</button>},
          {key: "delete",  label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={getLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]
  const onSubmit = () => {
      const payload = {
          detail: createPayload.detail,
          imageForm: image,
          subscriptionId: createPayload.subscriptionId,
          startDate: createPayload.startDate,
          url: createPayload.url,
        }
        postAction(payload)
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
  }
  const onSubmitApproval = (d) => {
      approvalAction(apPayload)
  }
  return (
    <PadContainer loading={getAdsLoad || getSubLoad}>
      <TitleContainer
        path={false}
        title="Ads Services"
        className="border border-lit rounded-xl"
        action={<Button onClick={onCreateOpen} className='!bg-light_blue' hidden type='primary' size='large' icon={<FaPlus />}>Add Ads</Button>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getAdsData?.data?.data}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isOpenApprove}
        onClose={onApproveClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Ads Approval</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitApproval}
          className='relative'
        >
          <Form.Item label="Status" valuePropName="checked">
            <Switch
              checkedChildren="active" 
              unCheckedChildren="inactive" 
              defaultChecked      
              value={apPayload.answer}
              onChange={(checked)=> setApPayload({...apPayload, answer: checked})}           
            />
          </Form.Item>
          <Form.Item label="Reason">
            <Input 
              size='large' 
              placeholder='Approval Reason' 
              value={apPayload?.request}
              onChange={({target:{value}})=> setApPayload({...apPayload, request: value})} 
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={approvalLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      
      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Ads Change Status</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Status" valuePropName="checked">
            <Switch
              checkedChildren="active" 
              unCheckedChildren="inactive" 
              defaultChecked      
              value={apPayload.answer}
              onChange={(checked)=> setApPayload({...apPayload, answer: checked})}           
            />
          </Form.Item>
          <Form.Item label="Reason">
            <Input 
              size='large' 
              placeholder='Approval Reason' 
              value={apPayload?.request}
              onChange={({target:{value}})=> setApPayload({...apPayload, request: value})} 
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={approvalLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Add Ad</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
          form={form}
        >
          <Form.Item label="Ads Detail" rules={[{required: true, message: 'Please input Ads Detail!',},]}>
            <Input 
                size='large' 
                placeholder='Enter Ads Detail' 
                prefix={<BiUser />} 
                value={createPayload.detail}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, detail: value})}
            />
          </Form.Item>

          <Form.Item label="Subscription">
            <Select 
                size='large' 
                placeholder='Select Subscription' 
                value={createPayload.subscriptionId}
                onChange={(value)=> setCreatePayload({...createPayload, subscriptionId: value})}
            >
              {getSubData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.title}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Start Date" className=''>
                <DatePicker 
                  size='large'
                  className='!w-full'
                  showTime  
                  onChange={(val, date)=> setCreatePayload({...createPayload, startDate: date})}
                />
            </Form.Item>
          <Form.Item label="URL">
            <Input 
                size='large' 
                className='!w-full' 
                value={createPayload.url}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, url: value})}
            />
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>            
            <Form.Item>
              <Upload {...uploadProps} listType="picture">
                <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Space size={12}>
                <Image
                  width={100}
                  src={createPayload.name}
                  placeholder={
                    <Image
                      preview={false}
                      src={createPayload.name}
                      width={200}
                    />
                  }
                />
              </Space>
            </Form.Item>
          </div>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmit} loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Create</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        // open={isOpenEdit}
        // onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Ad</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Ads Detail" rules={[{required: true, message: 'Please input Ads Detail!',},]}>
            <Input 
                size='large' 
                placeholder='Enter Ads Detail' 
                prefix={<BiUser />} 
                value={createPayload.detail}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, detail: value})}
            />
          </Form.Item>

          <Form.Item label="Subscription">
            <Select 
                size='large' 
                placeholder='Select Subscription' 
                value={createPayload.subscriptionId}
                onChange={(value)=> setCreatePayload({...createPayload, subscriptionId: value})}
            >
              {getSubData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.title}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Start Date" className=''>
                {/* <Input size='large' type='time' className='!w-full' /> */}
                <DatePicker 
                  size='large'
                  className='!w-full'
                  showTime  
                  onChange={(val, date)=> setDateTime(date)}
                />
            </Form.Item>
          <Form.Item label="URL">
            {/* <Input.TextArea placeholder='Enter description' size='large' rows={4} /> */}
            <Input 
                size='large' 
                className='!w-full' 
                value={createPayload.url}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, url: value})}
            />
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>            
            <Form.Item>
              <Upload {...uploadProps} listType="picture">
                <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
              </Upload>
            </Form.Item>
            <Form.Item>
              <Space size={12}>
                <Image
                  width={100}
                  src={createPayload.name}
                  placeholder={
                    <Image
                      preview={false}
                      src={createPayload.name}
                      width={200}
                    />
                  }
                />
              </Space>
            </Form.Item>
          </div>

          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Brands</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Brands image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default AdServices